<ngb-carousel [@loadedFadeAnimation]="model.length ? 'visible' : 'void'" *ngIf="model" id="carrusel__home">
  <ng-template ngbSlide *ngFor="let carrusel of model">

    <div *ngIf="carrusel.Url == null || carrusel.Url.length == 0" class="d-flex justify-content-center">
      <img [src]="carrusel.ImageFile.FileUri" [alt]="carrusel.Title">
    </div>

    <a *ngIf="carrusel.Url != null && carrusel.Url.length > 0 && carrusel.ExternalUrl == true" [href]="[carrusel.Url]" target="{{carrusel.UrlOpenNew == true? '_blank':''}}" class="d-flex justify-content-center">
      <img [src]="carrusel.ImageFile.FileUri" [alt]="carrusel.Title">
    </a>

    <div *ngIf="carrusel.Url != null && carrusel.Url.length > 0 && carrusel.ExternalUrl == false" [routerLink]="[carrusel.Url]" class="has-link d-flex justify-content-center">
      <img [src]="carrusel.ImageFile.FileUri" [alt]="carrusel.Title" style="display: block !important;">
    </div>

  </ng-template>
</ngb-carousel>